import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { Batch } from './batch.interface';

export class BatchService {
   async getBatch(batchId: number) {
      const response = await http.get<Batch>(`/batches/${batchId}`);
      return response.data;
   }
   async getBatches(query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<Batch>>(`/batches`, { params: { ...query } });
      return response.data;
   }
}
